// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'E:/www/yc-qy-front-react/src/models/contactModel';
import model_2 from 'E:/www/yc-qy-front-react/src/models/menuModel';
import model_3 from 'E:/www/yc-qy-front-react/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'contactModel', model: model_1 },
model_2: { namespace: 'menuModel', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
